module.exports = __webpack_public_path__ + "img/img25.fa4aa4d4.png";